<template>
  <div class="father">
    <nav>
      <div class="widthSet cursorPointer">
        <!-- 1200宽度↓ -->
        <!-- 第一行↓ -->
        <div class="info">
          <div class="leftInfo" @click="toLinkHome">
            <!-- ↓左盒子-->
            <div class="logo"><img :src="vuexAboutData.logo" alt=""></div>
            <div class="infotext">
              <p>沈阳市国际象棋协会</p>
              <p>Shenyang Chess Association</p>
            </div>
          </div><!-- ↑左盒子-->
          <div class="rightInfo">
            <!-- ↓右盒子-->
            <!-- 未登录状态↓ -->
            <div class="nonelogin" v-if="logintoken === false">
              <button @click="dialogloginVisible = true"><i class="el-icon-user-solid"></i>登录</button>
              <!-- <button  @click="dialoglogonVisible = true"><i class="el-icon-user"></i>注册</button> -->
              <button @click="dialoglogonVisible = true"><i class="el-icon-user"></i>注册</button>
              <el-tooltip placement="bottom">
                <div slot="content">如有疑问，请前往关于协会页<br />联系我们</div>
                <img src="../assets/css/img/what.png" alt="">
              </el-tooltip>
            </div>
            <!-- 未登录状态↑ -->
            <!-- 登录状态↓ -->
            <!-- 上方信息静态信息↓ -->
            <div class="loginok" v-else>
              <!-- 上方信息静态信息↓ -->
              <div class="rightAlign">
                <div v-if="accountInfotype === 1" class="rightAlign-item">
                  <span>欢迎你！{{personInfo.realName || "游客用户"}} </span>
                  <div class="viplogoBox" v-if="personInfo.isVip === 1"><img src="@/assets/css/member/vip.png"
                      class="viplogo"></img>
                    <div class="text">
                      认证会员
                    </div>
                  </div>
                  <div class="viplogoBox" v-else><img src="@/assets/css/member/novip.png" class="viplogo"></img>
                    <div class="notext">
                      非认证会员
                    </div>
                  </div>

                </div>
                <div v-else class="rightAlign-item"> <span>欢迎你！{{organInfo.orgSubName || "游客机构"}}</span>
                  &nbsp;<el-tooltip placement="right">
                    <div slot="content">已认证机构</div>
                    <!-- <span class="authlogo"><img  v-if="organInfostate === 1" src="@/assets/css/member/auth.png"></img></span> -->
                    <span class="authlogo"><img v-if="organInfostate === 1"
                        src="@/assets/css/member/auth.png"></img></span>
                  </el-tooltip>
                </div>
                <div v-if="accountInfotype === 1&&personInfo.isVip === 1" style="margin-bottom: 1rem;text-align: left;">
                  <span style="margin-right: 1rem;">会员码：{{personInfo.userCode}}</span>
                  <span>积分：{{personInfo.signScore}}</span>
                </div>
                <!-- <p  v-else>欢迎你！问问我游客机构</p> -->
              </div>
              <!-- 上方信息静态信息↑ -->
              <!-- 下方操作按钮↓ -->
              <div class="clicki">
                <div>
                  <button @click="toSign" v-if="isSignIn ==0">签到</button>
                  <button @click="toSign" v-if="isSignIn ==1"
                    style="background-color:#009a33;border: #009a33;">已签到</button>
                  <button @click="toVip">会员功能</button>
                  <button @click="toinfo">信息中心</button>
                  <button @click="loginout">退出登录</button>
                </div>
                <el-tooltip placement="bottom">
                  <div slot="content">如有疑问，请前往关于协会页<br />联系我们</div>
                  <img src="../assets/css/img/what.png" alt="">
                </el-tooltip>
              </div>
            </div>
            <!-- 登录状态↑ -->

          </div><!-- ↑右盒子-->
        </div>
        <!-- 第一行↑ -->

        <!-- 第二行↓ -->
        <!-- class="el-menu-demo" menu-trigger="click" -->
        <div class="tabSelect">
          <el-menu :default-active="activeIndexActive" mode="horizontal" @select="handleSelect"
            background-color="#76AFEC" text-color="#fff" active-text-color="#ffd04b">

            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2">协会公告</el-menu-item>
            <el-menu-item index="3">赛事中心</el-menu-item>
            <el-menu-item index="8">活动中心</el-menu-item>
            <el-menu-item index="4">新闻资讯</el-menu-item>
            <el-menu-item index="7">组织机构</el-menu-item>
            <el-menu-item index="5">会员单位</el-menu-item>
            <!-- <el-submenu index="5">
              <template slot="title">会员单位</template>
              <el-menu-item index="5-1">会员机构</el-menu-item>
              <el-menu-item index="5-2">会员学校</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="5-4">
                <template slot="title">选项4</template>
                <el-menu-item index="5-4-1">选项1</el-menu-item>
              </el-submenu> -->
            <el-menu-item index="6">关于协会</el-menu-item>
          </el-menu>
        </div>
        <!-- 第二行↑ -->


      </div> <!-- 1200宽度↑ -->

    </nav>

    <!-- 登录弹出层 :close-on-click-modal="false" 设置点击遮罩不关闭弹窗-->
    <el-dialog :visible.sync="dialogloginVisible" v-if="dialogloginVisible" :close-on-click-modal="false">
      <login @closelogin="closelogin"></login>
    </el-dialog>
    <!-- 注册弹出层 -->
    <el-dialog :visible.sync="dialoglogonVisible" v-if="dialoglogonVisible" :close-on-click-modal="false">
      <logon @closelogon="closelogon"></logon>
    </el-dialog>
    <!-- 待认证弹出层 -->
    <el-dialog :visible.sync="dialogauthVisible" v-if="dialogauthVisible" :close-on-click-modal="false">
      <!-- 个人认证弹出层 -->
      <auth v-if="accountInfotype == '1'" @closeauth="closeauth"></auth>
      <!-- 机构认证弹出层 -->
      <organauth v-else @closeorganauth="closeorganauth"></organauth>
    </el-dialog>
    <!-- Sign-in Modal -->
    <el-dialog :visible.sync="dialogSignInVisible" title="签到" :close-on-click-modal="false" class="calendar-dialog"
      width="45%" top="2vh">
      <div class="sign-in-calendar">
        <div class="calendar-header">
          <h1>{{ formattedDate }}</h1>
          <div class="month-display">
            <select v-model="selectedMonth" class="date-select" @change="getCanderDetail">
              <option v-for="month in monthOptions" :key="month" :value="month">{{ month + 1 }}月</option>
            </select>
          </div>
        </div>
        <div class="calendar-grid">
          <div class="weekday-header" v-for="day in weekDays" :key="day">{{ day }}</div>
          <div v-for="(day, index) in calendarDays" :key="index" :class="[
          'calendar-day',
          { 'current-month': day.currentMonth },

          { 'today': isToday(day.date) && !day.signed },
          { 'today-signed': isToday(day.date) && day.signed }
        ]" @click="signIn(day)">
            <span class="day-number" :class="{ 'today-day-number-nosign': isToday(day.date) && !day.signed}">{{ day.dayNumber }}</span>
            <div v-if="day.signed" class="circle-out">
              <span class="circle">√</span>
              <span class="points">+{{ day.points }}</span>
            </div>
            <div v-if="isToday(day.date) && !day.signed">
              点击签到
            </div>
            <!-- <span v-if="day.signed" class="points">+{{ day.points }}</span> -->
          </div>
        </div>
        <!-- <div class="sign-in-button-container">
          <button class="sign-in-button" @click="signInToday" :class="{ 'signed': isTodaySigned }">
            {{ isTodaySigned ? '今日已签到' : '立即签到' }}
          </button>
        </div> -->
      </div>
      <span slot="footer" style="display: flex; justify-content: center;margin-top: -3rem;">
        <el-button @click="dialogSignInVisible = false" style="width: 10rem; color: #fff;background-color: #0099ff;font-size: 1rem;font-weight: 600; height: 3rem;">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import request from '../utils/request'
  import '../assets/css/base.css'
  import '../assets/css/img/bigruIcon.jpg'
  import login from '@/components/Loginstart'
  import logon from '@/components/logonstart'
  import auth from '@/components/authstart'
  import organauth from '@/components/organauthstart'
  import {
    mapGetters
  } from 'vuex'

  export default {
    components: {
      login,
      logon,
      auth,
      organauth
    },
    data() {
      return {
        // isSignIn:'',
        activeIndexActive: "1", //tab选项卡 默认激活序号
        //是否已登录判断  true已登录 false未登录
        // login:this.logintoken || JSON.parse(sessionStorage.getItem('logintoken')) || false, 
        //使用vuex及本地存储赋值 保持响应及页面刷新不丢失  //若(vuex中state 或 本地存储)有值则为登录 若无值则为false（未登录）
        ispersonsign: false, //是否已签到

        dialogloginVisible: false, //登录弹出层
        dialoglogonVisible: false, //注冊弹出层
        dialogauthVisible: false, //待认证弹出层
        dialogSignInVisible: false,
        // 星期几的显示文本
        weekDays: ['一', '二', '三', '四', '五', '六', '日'],
        // 当前日期对象
        currentDate: new Date(),
        // 选中的月份
        selectedMonth: new Date().getMonth(),
        // 已签到日期数组
        signInDates: [],
        // 连续签到天数
        consecutiveDays: 0,
        // 是否显示消息
        showMessage: false,
        // 消息内容
        message: ''
      }
    },
    created() {
      if (this.personInfo && this.personInfo.isSignIn) {
        this.isSignIn = this.personInfo.isSignIn
      }
      
      this.activeIndexActive = this.tabIndexActive
      if (this.personInfoid) {
        this.getpersoninfoall()
      }


    },
    mounted() {
      // // 组件挂载时根据当前路由设置 activeIndexActive
      // const routeToIndexMap = {
      //   'home': '1',
      //   'Notice': '2',
      //   'move': '3',
      //   'activity': '8',
      //   'news': '4',
      //   'organ': '5', // 假设 'organ' 对应于 '5'
      //   'school': '5-2', // 假设 'school' 对应于 '5-2'
      //   'about': '6',
      //   'institution': '7'
      // };
      // const index = routeToIndexMap[this.$route.name];
      // console.log(this.$route.name,'index')
      // if (index) {
      //   this.$store.commit("updatetabIndexActive", index);
      //   // Vuex 状态变化会自动触发 watcher 更新 activeIndexActive
      // }

    },
    computed: {
      // vuex中开放的数据(均无法取到，因为 header文件 在未登录时就已经初始化渲染完成了  登录后)
      ...mapGetters([
        "personInfo",
        "organInfo",
        "logintoken", //token
        "personInfostate", //个人是否已认证
        "organInfostate", //机构是否已认证
        "accountInfotype", //登录类型为机构还是个人
        "tabIndexActive", //index
        "vuexAboutData",
        "personInfoid",
        "accountInfo"
      ]),
      isSignIn(){
        return this.personInfo.isSignIn
      },
      formattedDate() {
        return `${this.currentYear} 年 ${this.selectedMonth + 1} 月`;
      },
      // 获取当前年份
      currentYear() {
        return this.currentDate.getFullYear()
      },
      // 获取当前月份（0-11）
      currentMonth() {
        return this.currentDate.getMonth()
      },
      // 计算日历网格中显示的所有日期
      calendarDays() {
        const days = []
        const firstDay = new Date(this.currentYear, this.currentMonth, 1)
        const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0)

        // 填充上个月的日期
        const firstDayWeekday = firstDay.getDay() || 7
        for (let i = 1; i < firstDayWeekday; i++) {
          const date = new Date(this.currentYear, this.currentMonth, 1 - i)
          days.unshift({
            date,
            dayNumber: date.getDate(),
            currentMonth: false,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        // 填充当前月的日期
        for (let i = 1; i <= lastDay.getDate(); i++) {
          const date = new Date(this.currentYear, this.currentMonth, i)
          days.push({
            date,
            dayNumber: i,
            currentMonth: true,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        // 填充下个月的日期
        const remainingDays = 42 - days.length
        for (let i = 1; i <= remainingDays; i++) {
          const date = new Date(this.currentYear, this.currentMonth + 1, i)
          days.push({
            date,
            dayNumber: i,
            currentMonth: false,
            signed: this.isDateSigned(date),
            points: this.getSignInPoints(date)
          })
        }

        return days
      },
      // 判断今天是否已签到
      isTodaySigned() {
        const today = new Date()
        return this.isDateSigned(today)
      },
      // 月份选项
      monthOptions() {
        return Array.from({
          length: 12
        }, (_, i) => i);
      }
    },
    watch: {
      selectedMonth(newMonth) {
        // 更新currentDate为选中月份的日期
        this.currentDate = new Date(this.currentDate.getFullYear(), newMonth, 1);
      },
      // activeIndexActive(newValue) {
      //   console.log(newValue,'newValue')
      //   this.$store.commit("updatetabIndexActive",newValue)
      // },
      // 监听 Vuex 中的 tabIndexActive 变化
      '$store.state.tabIndexActive'(newValue) {
        this.activeIndexActive = newValue;
      },
      // 监听路由变化
      '$route'(to, from) {
        const routeToIndexMap = {
          'home': '1',
          'Notice': '2',
          'move': '3',
          'activity': '8',
          'news': '4',
          'organ': '5', // 这里假设 'organ' 对应于 '5', 如果有更细分的路由，可能需要进一步处理
          'school': '5-2', // 假设 'school' 对应于 '5-2'
          'about': '6',
          'institution': '7'
        };
        const index = routeToIndexMap[to.name];
        if (index) {
          this.$store.commit("updatetabIndexActive", index);
          // 由于 Vuex 状态变化会自动触发上面的 watcher，这里不需要再次设置 activeIndexActive
        }
      }
    },
    methods: {
      // 获取个人用户信息(存入vuex)
      async getpersoninfoall() {
        const {
          data
        } = await request({
          url: "/customer/PersonalUserInfo/getInfo",
          method: "POST",
          params: {
            personId: this.personInfoid,
          }
        })
        if (data.code == 200) {
          console.log(data.data)
          this.$store.commit("updatepersonInfo",data.data)
          // this.isSignIn = data.data.isSignIn
        }

      },
      async getCanderDetail() {
        try {
          const {
            data
          } = await request({
            method: 'post',
            url: `/sign/list`,
            params: {
              userId: this.personInfoid ? this.accountInfo.id : '',
              month: this.selectedMonth + 1
            },
          })
          if (data.code == 200) {
            console.log(data.data)
            //  item.signDate去掉-用， 替换
            data.data.forEach(item => {
              item.dateArray = item.signDate.split("-");
              // 将月份和日期转换为不带前导零的数字（如果需要）
              item.formattedMonth = parseInt(item.dateArray[1], 10); // 2
              item.formattedDay = parseInt(item.dateArray[2], 10); // 9
              item.formattedDate = `${item.dateArray[0]}, ${item.formattedMonth}, ${item.formattedDay}`
            })
            //  将data.data中的signDate转化成signInDates的格式
            this.signInDates = data.data.map(item => new Date(item.formattedDate));
            //     this.signInDates = [
            //   new Date(2025, 1, 6),
            //   new Date(2025, 1, 7),
            //   new Date(2025, 1, 8),
            //   new Date(2025, 1, 9),
            // ];
          } else {
            this.$message({
              message: data.msg,
              type: 'warning',
            })
          }
        } catch (error) {
          this.$message({
            message: error,
            type: 'warning',
          })
        }
      },
      // 判断给定日期是否为今天
      isToday(date) {
        const today = new Date()
        return date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear()
      },
      // 判断给定日期是否已签到
      isDateSigned(date) {
        return this.signInDates.some(signedDate => {
          const isSameDate =
            date.getDate() === signedDate.getDate() &&
            date.getMonth() === signedDate.getMonth() &&
            date.getFullYear() === signedDate.getFullYear();
          return isSameDate;
        });
      },
      // 获取签到积分（根据连续签到天数，最高5分）
      getSignInPoints(date) {
        if (!this.isDateSigned(date)) return 0

        // 找到当前日期在签到数组中的索引
        const index = this.signInDates.findIndex(signedDate =>
          signedDate.getDate() === date.getDate() &&
          signedDate.getMonth() === date.getMonth() &&
          signedDate.getFullYear() === date.getFullYear()
        )

        // 计算当前日期之前的连续签到天数
        let consecutiveDays = 1
        let prevDate = this.signInDates[index]

        // 向前查找连续签到的日期
        for (let i = index - 1; i >= 0; i--) {
          const currentDate = this.signInDates[i]
          const timeDiff = prevDate - currentDate
          const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

          if (daysDiff === 1) {
            consecutiveDays++
            prevDate = currentDate
          } else {
            break
          }
        }

        // 根据连续天数返回对应的积分（1-5分）
        return Math.min(consecutiveDays, 5)
      },
      // 获取指定索引位置的连续签到天数
      getConsecutiveDays(currentIndex) {
        let count = 1
        for (let i = currentIndex; i > 0; i--) {
          const diff = (this.signInDates[i] - this.signInDates[i - 1]) / (1000 * 60 * 60 * 24)
          if (diff !== 1) break
          count++
        }
        return count
      },
      // 点击日期进行签到
      signIn(day) {
        if(this.isToday(day.date) && !day.signed){
          console.log(day)
          this.signMethod()
        }
        return
        // 如果已签到或不是今天，则不允许签到

        if (day.signed || !day.currentMonth) return

        // 不允许签到未来日期
        const today = new Date()
        console.log(day.date)
        console.log(today)
        if (day.date > today) return

        // 添加新的签到日期
        const newDate = new Date(day.date.getFullYear(), day.date.getMonth(), day.date.getDate())
        this.signInDates.push(newDate)
        this.signInDates.sort((a, b) => a - b)

        // 更新连续签到天数
        const lastIndex = this.signInDates.length - 1
        let consecutiveDays = 1
        let prevDate = this.signInDates[lastIndex]

        // 向前查找连续签到的日期
        for (let i = lastIndex - 1; i >= 0; i--) {
          const currentDate = this.signInDates[i]
          const timeDiff = prevDate - currentDate
          const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

          if (daysDiff === 1) {
            consecutiveDays++
            prevDate = currentDate
          } else {
            break
          }
        }

        this.consecutiveDays = consecutiveDays
      },
      // 点击按钮签到今天
      signInToday() {
        const today = new Date()
        if (this.isTodaySigned) {
          // this.$message.success('您今日已签到')
          return
        }

        // // 添加今天的签到记录
        // const newDate = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        // this.signInDates.push(newDate)
        // this.signInDates.sort((a, b) => a - b)

        // // 更新连续签到天数
        // const lastIndex = this.signInDates.length - 1
        // let consecutiveDays = 1
        // let prevDate = this.signInDates[lastIndex]

        // // 向前查找连续签到的日期
        // for (let i = lastIndex - 1; i >= 0; i--) {
        //   const currentDate = this.signInDates[i]
        //   const timeDiff = prevDate - currentDate
        //   const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24))

        //   if (daysDiff === 1) {
        //     consecutiveDays++
        //     prevDate = currentDate
        //   } else {
        //     break
        //   }
        // }

        // this.consecutiveDays = consecutiveDays
        // 调用签到接口
        this.signMethod()

      },
      async signMethod() {
        try {
          const {
            data
          } = await request({
            method: 'post',
            url: `/sign/add`,
            params: {
              userId: this.personInfoid ? this.accountInfo.id : '',
            },
          })
          if (data.code == 200) {
            this.$message.success('签到成功！')
            this.getpersoninfoall()
            this.getCanderDetail()
          } else {
            this.$message({
              message: data.msg,
              type: 'warning',
            })
          }
        } catch (error) {
          this.$message({
            message: error,
            type: 'warning',
          })
        }
      },
      toSign() {
        this.getCanderDetail()
        this.dialogSignInVisible = true;
      },
      // 前往vip功能
      toVip() {
        this.$message.warning('暂未开通，敬请期待！')
        return
        if (this.personInfo.isVip == 0) {
          return this.$message.warning('如果需要使用此功能请成为"认证会员"')
        }
        this.$router.push({
          name: 'vipFunction'
        })
      },
      // tab下拉事件
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        //  每次点击时  都存入index值  防止刷新后 默认为首页index
        this.$store.commit("updatetabIndexActive", key)
        //  key : router
        const indexObj = {
          "1": () => this.$router.push({
            name: "home"
          }),
          "2": () => this.$router.push({
            name: "Notice"
          }),
          "3": () => this.$router.push({
            name: "move"
          }),
          "8": () => this.$router.push({
            name: "activity"
          }),
          "4": () => this.$router.push({
            name: "news"
          }),
          "5": () => this.$router.push({
            name: "organ"
          }),
          "5-1": () => this.$router.push({
            name: "organ"
          }),
          "5-2": () => this.$router.push({
            name: "school"
          }),
          "6": () => this.$router.push({
            name: "about"
          }),
          "7": () => this.$router.push({
            name: "institution"
          }),
        }
        if (indexObj[key]) {
          indexObj[key]()
        } else {
          console.log("执行错误")
        }

      },
      //签到
      personsign() {
        // 提示已签到
        this.$message({
          type: 'success',
          message: '签到成功'
        });
        // 发起请求 获取状态

        //将签到变为已经签到
        this.ispersonsign = true
      },
      // 审核中提示
      verifyinfo() {
        this.$message({
          type: 'warning',
          message: '机构信息审核中，请耐心等待'
        });
      },
      toinfo() {
        // 判断 类型是机构注册 还是个人注册
        if (this.accountInfotype == "1") {
          // 跳转个人信息页面
          this.$router.push({
            name: 'accountInfopersoninfor'
          })
        } else {
          // 跳转机构信息页面
          this.$router.push({
            name: 'organInfopersoninfor'
          })
        }
      },
      // 退出登录机构
      loginout() {
        this.$confirm('您确定要退出当前账号吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          confirmButtonClass: "el-button--success",
        }).then(async () => {
          // 更改为未登录状态
          // 将token 存入（清空）vuex
          await this.$store.commit("savetoken", false)
          // 清空vuex及本地存储的用户数据
          this.$store.commit("updateaccountInfo", {})
          this.$store.commit("updateorganInfo", {})
          this.$store.commit("updatepersonInfo", {})
          // 滚动到最顶部 再跳转到首页
          document.documentElement.scrollTop = 0
          // 跳转到首页
          this.$router.push({
            path: '/'
          })
          // 将 index索引值存入vuex
          this.$store.commit("updatetabIndexActive", "1")

          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }).catch(() => {});
      },
      // 退出登录个人
      loginoutperson() {
        this.$confirm('您确定要退出当前账号吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          confirmButtonClass: "el-button--success",
        }).then(async () => {
          // 更改为未登录状态
          // 将token 存入（清空）vuex
          await this.$store.commit("savetoken", false)
          // 清空vuex及本地存储的用户数据
          this.$store.commit("updateaccountInfo", {})
          this.$store.commit("updatepersonInfo", {})

          // 滚动到最顶部 再跳转到首页 
          document.documentElement.scrollTop = 0
          // 跳转到首页
          this.$router.push({
            path: '/'
          })
          // 将 index索引值存入vuex
          this.$store.commit("updatetabIndexActive", "1")

          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }).catch(() => {});
      },
      closelogon(val) {
        // 子传父 关闭注册弹层事件
        this.dialoglogonVisible = val
      },
      closelogin(val) {
        // 子传父 关闭登录弹层事件 并且更改显示状态
        this.dialogloginVisible = val

        // 手动更改显示状态
        this.login = true
      },
      closeauth(val) {
        // 子传父 个人认证关闭
        this.dialogauthVisible = val
      },
      closeorganauth(val) {
        // 子传父 机构认证关闭
        this.dialogauthVisible = val
      },
      // 点击logo 跳转首页
      toLinkHome() {
        this.$router.push({
          name: "home"
        })
      }
    }
  }

</script>


<style lang="less" scoped>
// .father{
//   padding-top: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
nav {
  // height: 190px;
  // width: 1341px;

  // padding: 10px 0px;
  /* 导航栏背景色 */
  // background-color: #8B4513;
  background-image: linear-gradient(to top, #fe80b1, #76afec);
  display: flex;

  // justify-content: center;
  justify-content: center;
  align-items: center;
  // flex-wrap: wrap;
  // align-content:flex-start;
}

// 宽度设置盒子
.widthSet {
  padding-top: 10px;
  width: 1341px;
  // width: 1394px;
}

// 左侧盒子(图标信息)
.leftInfo {
  display: flex;
  align-items: center;
}

// 右侧盒子（tab + 按钮）
// .rightInfo{
//   // display: flex;
//   // align-items: center;
//   // justify-content: space-between;
// }
// ↑↑ 右侧盒子（tab + 按钮）

/* 未登录盒子 */
.nonelogin {
  // margin-right: 260px;
  // min-width: 180px;
  // display: flex;
  // justify-content: space-between;
  text-align: right;
  width: 300px;
  padding-bottom: 5px;

  img {
    padding-bottom: 8px;
  }
}

.nonelogin button {
  background-color: #4866db;
  width: 80px;
  height: 34px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  margin-right: 10px;
  /* 虚线边框 */
  // border: 1px dashed #808080;
  border: 1px solid #808080;
}

.nonelogin button:last-child {
  margin-left: 20px;
}

/* ------------------------------ */
/* 登录盒子 */
.rightAlign {
  // text-align: right;
  padding-right: 15px;
  padding-left: 15px;

  .rightAlign-item {
    display: flex;
    align-items: center;

    padding-bottom: 10px;

    .viplogoBox {
      .viplogo {
        width: 2.2rem;
        height: 2.2rem;
        margin-left: 2rem;
        z-index: 999;
      }

      display: flex;
      font-size: 1rem;
      align-items: center;

      .text {
        padding: 0.1rem 1rem;
        margin-left: -1rem;
        background-color: rgba(210, 162, 95, 0.7);
      }

      .notext {
        padding: 0.1rem 1rem;
        margin-left: -1rem;
        background-color: rgba(203, 201, 204, 0.7);
      }
    }
  }
}

.loginok {
  min-width: 240px;
  display: flex;
  flex-direction: column;
  // min-width: 144px;  //待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  align-content: center;
  // justify-content: flex-start;
  // padding-bottom: 10px;
  // margin-right: 260px;
}

.loginok {
  letter-spacing: 0px !important;
  color: #ffffff;
  font-size: 18px;
  margin-bottom: 10px;
}

/* 按钮+图标 */
.clicki {
  min-width: 210px;
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clicki button {
  background-color: #4866db;
  /* width: 80px; */
  height: 33px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  width: 80px;
  // padding: 0 5px;
  /* 虚线边框 */
  // border: 1px dashed #808080;
  border: 1px solid #808080;
  margin: 0 10px 0 0;
}

.clicki img {
  color: #4866db;
  width: 26px;
  height: 26px;
}

.btninfo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btninfo button {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 33px;
  line-height: 33px;
}

.btninfo button p {
  margin-bottom: 0px;
  font-size: 17px;
}

/* ------------------------------ */

/* ------------------------------ */

// 顶部tab
/* 路由盒子 */
.tag {
  width: 900px;
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  // justify-content: space-around;
  // min-width: 570px;//待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  // min-width: 830px;//待确认设置最小宽度是否可行  可能会造成部分用户电脑出现滚动条
  // height: 50px;
  // line-height: 50px;
  // flex: auto;
  // margin-left: 120px;
  // margin-right: 50px;
}

nav a {
  color: #ffffff;
  font-size: 18px;
  margin-right: 27px;
  padding-bottom: 15px;
}

nav a:last-child {
  margin-right: 0px;
}

nav a.router-link-exact-active {
  color: #4866db;
  border-bottom: 6px solid #4866db;
}

/* ------------------------------------- */
// 弹窗
/deep/ .el-dialog {
  width: 600px;
  // height: 580px !important; 不定义高度 让其随内容自适应
  border-radius: 10px;
  // box-shadow :5px 5px   rgb(1,1,1, 0.01);
  padding: 0px 60px 40px;
}

// /deep/ .el-dialog__header {
//   background-color: #0099ff;

//   font-weight: 600;
// }

// /deep/ .el-dialog__title {
//   color: #fff !important;
//   font-size: 1.3rem;
// }

// /deep/ .el-dialog__headerbtn .el-dialog__close {
//   color: #fff !important;
//   font-size: 1.6rem;
// }
// /deep/ .el-dialog__body {
//   padding: 1rem 5rem;
// }
.authlogo {
  padding-top: 0px;
}

.authlogo img {
  width: 18px;
  margin-top: -2px;
}

/* 第一行 */
.info {
  margin: 20px 0px 15px 0px;
  width: 1341px;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  // padding-right: 25px;
}

.infotext {
  text-align: left;
  // width: 350px;
  margin-left: 10px;
}

.info p:first-child {
  font-size: 22px;
  letter-spacing: 4px;
}

.info p:last-child {
  font-size: 18px;
}

//顶部
.logo {
  width: 80px;
  // height: 99px;
}

.logo img {
  width: 100%;
  height: 100%;
}

// 第二行  下方tab
.tabSelect {
  width: 1341px;
  text-align: center;
}

/deep/ .el-menu-item {
  font-size: 18px;
  height: 60px !important;
  line-height: 60px !important;
  padding: 0px 50px;
}

/deep/ .el-menu-item:last-child {
  padding: 0px 50px;
}

/deep/.el-submenu__title {
  font-size: 18px;
  height: 60px !important;
  line-height: 60px !important;
  padding: 0px 50px;
}

// 整个tab的样式
// .el-menu--horizontal{
//   position: absolute;
//   top: 189px;
//   left: 803px;
//   z-index: 2050;
// }
.el-menu--popup-bottom-start {
  min-width: 100px !important;
}

.el-menu--horizontal .el-menu .el-menu-item {
  display: flex;
  justify-content: center;
  padding: none;
  font-size: 16px;
}

/deep/.el-submenu__icon-arrow {
  font-size: 20px;
  color: #ffffff;
}

.calendar-dialog {
  // 弹窗
  /deep/ .el-dialog {
    // width: 600px !important;
    width: 4rem;
    // height: 580px !important; 不定义高度 让其随内容自适应
    border-radius: 10px;
    // box-shadow :5px 5px   rgb(1,1,1, 0.01);
    padding: 0;
  }

  /deep/ .el-dialog__header {
    background-color: #0099ff;

    font-weight: 600;
  }

  /deep/ .el-dialog__title {
    color: #fff !important;
    font-size: 1.3rem;
  }

  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
    font-size: 1.6rem;
  }
  /deep/ .el-dialog__body {
    padding: 1rem 5rem;
  }
  // background-color: #3498db; // 设置弹窗背景色为蓝色
  .sign-in-calendar {
    // max-width: 800px;
    margin: 1rem auto 2.5rem;
    padding: 1.5rem;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      sans-serif;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
  }

  .calendar-header {
    text-align: center;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .calendar-header h1 {
    font-size: 1.6rem;
    color: #2c3e50;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  .month-display {
    position: absolute;
    font-size: 1.1rem;
    color: #7f8c8d;
    margin: 0.5rem 0;
    font-weight: 400;
    // float: right;
    right: 0;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1.5rem;
    background-color: #fcfcfc;
    border-radius: 12px;
    padding: 12px;
  }

  .weekday-header {
    background-color: transparent;
    color: #7f8c8d;
    padding: 8px;
    text-align: center;
    font-weight: 500;
    font-size: 0.85rem;
  }

  .calendar-day {
    background-color: #fff;
    padding: 8px;
    min-height: 4.5rem;
    position: relative;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.15s ease;
    border: 1px solid #ccc;
    overflow: visible;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    margin: 0;
    width: 100%;
  }

  .calendar-day.signed {
    background-color: #f8fafd;
    border: 1px solid #edf2f7;
    color: #3498db;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: 8px;
  }

  .calendar-day:not(.current-month) {
    opacity: 0.5;
    background-color: #f8f9fa;
    cursor: default;
  }

  .calendar-day:not(.current-month) .day-number {
    color: #adb5bd;
  }

  .calendar-day:not(.current-month).signed {
    background-color: #f8f9fa;
    border-color: #e9ecef;
  }

  .calendar-day:not(.current-month) .points {
    background-color: #adb5bd;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    background-color: #fcfcfc;
    border-radius: 12px;
    padding: 12px;
    width: 100%;
  }

  .day-number {
    // position: absolute;
    // top: 4px;
    // left: 4px;
    font-size: 1rem;
    font-weight: 400;
    color: #34495e;
  }
  .today-day-number-nosign {
    color: #fff;
  }

  .signed {
    background-color: #f8fafd;
    border: 1px solid #edf2f7;
    border-radius: 8px;
    color: #3498db;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    margin: 0 10px;
    padding: 6px 12px;
    transition: all 0.2s ease;
  }

  .date-select {
    padding: 4px 8px;
    font-size: 0.9rem;
    border: 1px solid #e0e0e0;
    background-color: white;
    color: #7f8c8d;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 4px;
    transition: all 0.15s ease;
    outline: none;
  }

  .date-select:hover {
    border-color: #3498db;
  }

  .date-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
  }

  .circle-out {
    position: absolute;
    bottom: 2px;
    left: 1.5rem;
  }

  .circle {
    background-color: #009a33;
    color: white;
    padding: 0.18rem 0.65rem;
    border-radius: 50%;
    font-size: 1rem;
    font-weight: 400;
    text-align: center;
  }

  .points {
    color: #009a33;
  }

  // .points {
  //   position: absolute;
  //   bottom: 2px;
  //   right: 2px;
  //   background-color: #009a33;
  //   color: white;
  //   padding: 0px 2px;
  //   border-radius: 4px;
  //   font-size: 0.6rem;
  //   font-weight: 400;
  //   min-width: 16px;
  //   text-align: center;
  // }

  .today {
    // border: 1px solid #3498db;
    background-color: #fe9900;
    color: #fff;
  }
  .today-signed {
    border: 1px solid #fe9900;
    // background-color: #fe9900;
    // color: #fff;
  }
  // .today::after {
  //   content: '今';
  //   position: absolute;
  //   top: -2px;
  //   right: -2px;
  //   background-color: #3498db;
  //   color: white;
  //   padding: 0.2rem;
  //   border-radius: 4px;
  //   font-size: 0.6rem;
  //   font-weight: 400;
  //   line-height: 1;
  // }

  .sign-in-button-container {
    text-align: center;
    margin-top: 2rem;
  }

  .sign-in-button {
    padding: 0.4rem 1.5rem;
    font-size: 0.8rem;
    border: none;
    border-radius: 30px;
    background-color: #3498db;
    color: white;
    cursor: pointer;
    transition: all 0.15s ease;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  .sign-in-button:hover:not(.signed) {
    background-color: #2980b9;
    transform: translateY(-1px);
  }

  .sign-in-button.signed {
    background-color: #009a33;
    color: #fff;
    cursor: not-allowed;
  }
}
</style>
